module.exports = __webpack_public_path__ + "static/img/zjgn.8f59c4d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doubleQianNiu/zjgn.jpg
// module id = 1423
// module chunks = 0